
const newModel = () => {
    return {
        phanloaiDiadiemId: null,
        loaiDiadiemId: null, //Khóa ngoại
        ten: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

const newFEModel = () => {
    return {
        phanloaiDiadiemId: null,
        loaiDiadiemId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        loaiDiadiemId: item.loaiDiadiemId,
        phanloaiDiadiemId: item.phanloaiDiadiemId,
        tenLoaiDiadiem: item.tenLoaiDiadiem,
        ten: item.ten,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        loaiDiadiemId: item.loaiDiadiemId,
        phanloaiDiadiemId: item.phanloaiDiadiemId,
        ten: item.ten,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        loaiDiadiemId: null,
        ten: null,
        phanloaiDiadiemId: null,
        enabled: null,
    }

}

const errors = () => {
    return {
        phanloaiDiadiemId: null,
        loaiDiadiemId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

export const phanLoaiDiaDiemModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    newPagingSearchModel,
    fromJson,
    errors,
}


